import { c as _c } from "react/compiler-runtime";
import Drops from "@/components/drops/view/Drops";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { ReactNode } from "react";
import UserPageBrainActivity from "./UserPageBrainActivity";
import UserPageBrainSidebar from "./UserPageBrainSidebar";
export default function UserPageDrops(t0) {
  const $ = _c(12);
  const {
    profile
  } = t0;
  let content = null;
  if (profile) {
    const haveProfile = Boolean(profile.handle);
    let t1;
    if ($[0] !== profile) {
      t1 = <UserPageBrainActivity profile={profile} />;
      $[0] = profile;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== haveProfile) {
      t2 = haveProfile && <Drops />;
      $[2] = haveProfile;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = <div className="tw-order-2 tw-min-w-0 tw-space-y-6 lg:tw-order-1">{t1}{t2}</div>;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== profile) {
      t4 = <UserPageBrainSidebar profile={profile} />;
      $[7] = profile;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
      t5 = <div className="tailwind-scope"><div className="tw-grid tw-grid-cols-1 tw-gap-x-8 tw-gap-y-6 lg:tw-grid-cols-[minmax(0,2fr)_minmax(22rem,1fr)] xl:tw-gap-x-10">{t3}{t4}</div></div>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    content = t5;
  }
  return content;
}